var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Card } from '@philips-internal/oswald-ui-components/lib/components';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { eventListener } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { isFunction } from '@philips-internal/oswald-ui-utils';
import React, { Component } from 'react';
import { ReservedBloodProductsStatus } from './blood-management-details-card-types';
import { SelectionType } from '@philips-internal/oswald-ui-constants';
import { generateUUID } from '@philips-internal/oswald-ui-utils';
import moment from 'moment';
import BloodManagementDetailsCardAPI from './blood-management-details-card-api';
import { ReactComponent as SuspendedIcon } from '../../assets/images/global/block.svg';
import { ReactComponent as Checked } from '../../assets/images/global/checked.svg';
import { ReactComponent as CirclePause } from '../../assets/images/global/circle-pause.svg';
import { ReactComponent as CirclePlay } from '../../assets/images/global/circle-play.svg';
import { ReactComponent as RestartedIcon } from '../../assets/images/global/circular-arrow-restarted.svg';
import { ReactComponent as ClockYellow } from '../../assets/images/global/clock-yellow.svg';
import { ReactComponent as PatientCheck } from '../../assets/images/global/patient-check.svg';
import { ReactComponent as PatientClock } from '../../assets/images/global/patient-clock.svg';
import { ReactComponent as PatientFirst } from '../../assets/images/global/patient-first.svg';
import { ReactComponent as PillCrusherClock } from '../../assets/images/global/pill-crusher-clock.svg';
import { ReactComponent as PillCrusherEye } from '../../assets/images/global/pill-crusher-eye.svg';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import './blood-management-details-card.css';
var MedicationStatus;
(function (MedicationStatus) {
    MedicationStatus["ADMINISTERED"] = "ADMINISTERED";
    MedicationStatus["CHECKED_FIRST"] = "CHECKED_FIRST";
    MedicationStatus["INTERRUPTED"] = "INTERRUPTED";
    MedicationStatus["PENDING"] = "PENDING";
    MedicationStatus["PENDING_REFUSAL"] = "PENDING_REFUSAL";
    MedicationStatus["PREPARATION"] = "PREPARATION";
    MedicationStatus["REFUSED_ADMINISTERED"] = "REFUSED_ADMINISTERED";
    MedicationStatus["STARTED"] = "STARTED";
})(MedicationStatus || (MedicationStatus = {}));
let BloodManagementDetailsCard = class BloodManagementDetailsCard extends Component {
    constructor() {
        super(...arguments);
        this.handleClick = () => {
            const { administrationRoute, isChemotherapy, chemotherapyStatus, currentSpeedInfusion, description, despisedVolumeQty, dilution, doseQuantity, emarStepScheduleNumber, endDate, infusedVolumeQty, observation, onClick, orderSequence, prescriptionId, processNumber, statusDate, unitMeasurement, volumeInStepQty, } = this.props;
            if (isFunction(onClick)) {
                onClick(new ClickEvent({
                    value: {
                        administrationRoute,
                        chemotherapyStatus,
                        currentSpeedInfusion,
                        description,
                        despisedVolumeQty,
                        dilution,
                        doseQuantity,
                        emarStepScheduleNumber,
                        endDate,
                        infusedVolumeQty,
                        isChemotherapy,
                        observation,
                        onClick,
                        orderSequence,
                        prescriptionId,
                        processNumber,
                        statusDate,
                        unitMeasurement,
                        volumeInStepQty,
                    }
                }));
            }
        };
    }
    static { this.propTypes = {
        onClick: eventListener
    }; }
    renderItemTitle(icon, titleOne, titleTwo) {
        return (React.createElement("div", { className: 'c-blood-management-details-card__description-name' },
            React.createElement("div", { className: 'c-blood-management-details-card__pill-crusher-eye' }, icon),
            React.createElement("span", { className: 'c-blood-management-details-card__description-name-text' }, titleOne || titleTwo)));
    }
    renderDefaultItem(textTitle, itemValue, className) {
        return (React.createElement("div", { className: `c-blood-management-details-card__default-infos ${className}` },
            React.createElement("span", { className: 'c-blood-management-details-card__default-title' }, textTitle),
            React.createElement("span", { className: 'c-blood-management-details-card__default-text' }, itemValue && itemValue)));
    }
    renderIcon(hourStatus) {
        switch (hourStatus) {
            case MedicationStatus.ADMINISTERED:
            case ReservedBloodProductsStatus.TERMINATE:
                return React.createElement(Checked, null);
            case MedicationStatus.CHECKED_FIRST:
                return React.createElement(PatientFirst, null);
            case MedicationStatus.INTERRUPTED:
            case ReservedBloodProductsStatus.INTERRUPTED:
                return React.createElement(CirclePause, null);
            case MedicationStatus.PENDING:
            case ReservedBloodProductsStatus.PENDING:
                return React.createElement(ClockYellow, null);
            case MedicationStatus.PENDING_REFUSAL:
                return React.createElement(PatientClock, null);
            case MedicationStatus.PREPARATION:
                return React.createElement(PillCrusherClock, null);
            case MedicationStatus.REFUSED_ADMINISTERED:
                return React.createElement(PatientCheck, null);
            case MedicationStatus.STARTED:
            case ReservedBloodProductsStatus.STARTED:
                return React.createElement(CirclePlay, null);
            case 'A':
                return React.createElement(Checked, null);
            case 'C':
                return React.createElement(PatientCheck, null);
            case 'J':
                return React.createElement(PatientClock, null);
            case 'L':
                return React.createElement(PillCrusherEye, null);
            case 'N':
                return React.createElement(ClockYellow, null);
            case 'P':
                return React.createElement(PillCrusherClock, null);
            case 'Q':
                return React.createElement(PatientFirst, null);
            case ReservedBloodProductsStatus.RESTARTED:
                return React.createElement(RestartedIcon, null);
            case ReservedBloodProductsStatus.SUSPEND:
                return React.createElement(SuspendedIcon, null);
            default:
                return null;
        }
    }
    renderDescriptionName() {
        const { description, hourStatus, materialDescription, statusItem } = this.props;
        const statusItemValue = hourStatus || statusItem;
        return (this.renderItemTitle(this.renderIcon(statusItemValue), description, materialDescription));
    }
    renderContent() {
        const { currentSpeedInfusion, expirationDate, statusItemDescription, reservationDate, reservationNumber, bloodNumber, scheduleDate, totalVolume, unitMeasurement, } = this.props;
        const formattedDate = moment(String(scheduleDate)).format('L LTS');
        const isReservedBlood = reservationNumber && expirationDate;
        const renderReservedBloodContent = () => (React.createElement("div", { className: 'c-blood-management-details-card__content' },
            React.createElement("div", { className: 'c-blood-management-details-card__content-up' },
                React.createElement("div", { className: 'c-blood-management-details-card__content-up-left' },
                    reservationDate != null && (this.renderDefaultItem(MessageService.translate('txt.reservation-date'), moment(String(reservationDate)).format('L LTS'), '')),
                    reservationNumber != null && (this.renderDefaultItem(MessageService.translate('txt.reservation-number'), String(reservationNumber), '')),
                    currentSpeedInfusion != null && (this.renderDefaultItem(MessageService.translate('text.infusion-rate'), String(currentSpeedInfusion), '')),
                    totalVolume != null && (this.renderDefaultItem(MessageService.translate('text.volume-ml'), String(totalVolume), 'padding-right'))),
                React.createElement("div", { className: 'c-blood-management-details-card__content-up-right' },
                    expirationDate != null && (this.renderDefaultItem(MessageService.translate('txt.due-date'), moment(String(expirationDate)).format('L LTS'), 'padding-right')),
                    bloodNumber != null && (this.renderDefaultItem(MessageService.translate('txt.blood-number'), String(bloodNumber), 'padding-right')),
                    unitMeasurement != null && (this.renderDefaultItem(MessageService.translate('text.abbreviation.unit-of-measurement'), String(unitMeasurement), 'padding-right')),
                    statusItemDescription != null && (this.renderDefaultItem(MessageService.translate('tws.txt-status'), String(statusItemDescription), ''))))));
        const renderNonReservedBloodContent = () => (React.createElement("div", { className: 'c-blood-management-details-card__content' },
            React.createElement("div", { className: 'c-blood-management-details-card__content-up' },
                React.createElement("div", { className: 'c-blood-management-details-card__content-up-left' },
                    scheduleDate && this.renderDefaultItem(MessageService.translate('text.start-date'), formattedDate, ''),
                    currentSpeedInfusion != null && this.renderDefaultItem(MessageService.translate('text.infusion-rate'), String(currentSpeedInfusion), '')),
                React.createElement("div", { className: 'c-blood-management-details-card__content-up-right' },
                    totalVolume != null && this.renderDefaultItem(MessageService.translate('text.volume-ml'), String(totalVolume), ''),
                    unitMeasurement != null && this.renderDefaultItem(MessageService.translate('text.abbreviation.unit-of-measurement'), String(unitMeasurement), 'padding-right')))));
        return isReservedBlood ? renderReservedBloodContent() : renderNonReservedBloodContent();
    }
    render() {
        const { orderSequence } = this.props;
        return (React.createElement(Card, { className: 'c-blood-management-details-card', selectionType: SelectionType.SINGLE, uuid: generateUUID(), key: orderSequence, width: 12 },
            React.createElement("div", { className: 'c-blood-management-details-card__wrapper' },
                this.renderDescriptionName(),
                this.renderContent())));
    }
};
BloodManagementDetailsCard = __decorate([
    AwesomeComponent({ api: BloodManagementDetailsCardAPI, type: ComponentType.DATA_DISPLAY })
], BloodManagementDetailsCard);
export default BloodManagementDetailsCard;
//# sourceMappingURL=blood-management-details-card.js.map